//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ApiKeyMode } from './Enums';

export class ApiKeyInputItem extends ItemBase {
    Name: string | null = null;
    Description: string | null = null;
    Mode: ApiKeyMode = ApiKeyMode.Read;
    Enabled: boolean = false;

    constructor(initializer?: Partial<ApiKeyInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ApiKeyInputItem";
}
